import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MeristemExperiment, Targeting } from "src/utils/meristemContext";

export type StartEventsState = Record<string, Record<string, Targeting>>;

/**
 * Returns an object of Meristem experiments and their startEvents
 * This object is in the shape of
 * {
 *   experimentName: { startEvent: { filters }, ... },
 *   ...
 * }
 */
function extractStartEvents(
  meristemExperiments: MeristemExperiment[]
): StartEventsState {
  const startEvents = {};
  if (meristemExperiments) {
    meristemExperiments.forEach((meristemExperiment) => {
      const experimentName = meristemExperiment.name;
      if (meristemExperiment.startEvents) {
        startEvents[experimentName] = {};
        meristemExperiment.startEvents.forEach((startEvent) => {
          const { filters } = startEvent;
          startEvents[experimentName][startEvent.name] = {
            filters,
          };
        });
      }
    });
  }
  return startEvents;
}

const startEventsSlice = createSlice({
  name: "startEvents",
  initialState: {} as StartEventsState,
  reducers: {
    updateStartEvents(state, action: PayloadAction<MeristemExperiment[]>) {
      return extractStartEvents(action.payload) || state;
    },
  },
});

export const { updateStartEvents } = startEventsSlice.actions;

export default startEventsSlice.reducer;
